/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type WYSIWYGViewerWithFeatureFlag_organization$ref = any;
export type TacticalOutputType = "ACTION" | "INFORMATION" | "PROJECT" | "TENSION";
import type { FragmentReference } from "relay-runtime";
declare export opaque type OutputDescription_output$ref: FragmentReference;
declare export opaque type OutputDescription_output$fragmentType: OutputDescription_output$ref;
export type OutputDescription_output = {|
  +type: TacticalOutputType,
  +description: string,
  +privateToCircle: boolean,
  +organization: {|
    +$fragmentRefs: WYSIWYGViewerWithFeatureFlag_organization$ref
  |},
  +$refType: OutputDescription_output$ref,
|};
export type OutputDescription_output$data = OutputDescription_output;
export type OutputDescription_output$key = {
  +$data?: OutputDescription_output$data,
  +$fragmentRefs: OutputDescription_output$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "OutputDescription_output",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "privateToCircle",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Organization",
      "kind": "LinkedField",
      "name": "organization",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "WYSIWYGViewerWithFeatureFlag_organization"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TacticalOutput",
  "abstractKey": null
};
// prettier-ignore
(node/*: any*/).hash = '939c27fb64a2c89709628a7ecceba15d';

module.exports = node;
